import React from 'react';
import { useTranslation } from 'react-i18next';

import { ViewSettings } from '../../../viewer/view-settings';
import { Icon } from '../icon/icon';
import { Tooltip } from '../tooltip/tooltip';
import { RoundButton } from './round-button';
import { useViewSettings } from './toolbar/tools/view-settings/use-view-settings';

/**
 * Switches the perspective camera between orbiting and flying freely, showing the current one,
 * with the other one in the tooltip.
 */
const CameraControlToggle = () => {
  const { t } = useTranslation();
  // Re-renders when the camera control changes
  useViewSettings();
  const flying = ViewSettings.instance.cameraControl === 'fly';

  const tooltip = flying
    ? {
        title: t('viewSettings.cameraControl.orbit.title', { ns: 'skyviewToolbar' }),
        text: t('viewSettings.cameraControl.orbit.text', { ns: 'skyviewToolbar' }),
      }
    : {
        title: t('viewSettings.cameraControl.fly.title', { ns: 'skyviewToolbar' }),
        text: t('viewSettings.cameraControl.fly.text', { ns: 'skyviewToolbar' }),
      };

  return (
    <Tooltip content={tooltip.text} mainAxisOffset={10} placement="bottom" title={tooltip.title}>
      <RoundButton
        $active={flying}
        aria-label={t('viewSettings.cameraControl.fly.title', { ns: 'skyviewToolbar' })}
        aria-pressed={flying}
        type="button"
        onClick={() => ViewSettings.instance.setCameraControl(flying ? 'orbit' : 'fly')}
      >
        <Icon icon={flying ? ['fal', 'plane'] : ['fal', 'arrows-spin']} />
      </RoundButton>
    </Tooltip>
  );
};

export { CameraControlToggle };
